import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../helpers";
import { CompanyProfileModel, KYCDocumentsModel } from "../../_models";
import { PartnerService } from "../../_services/partner/partner.service";
import { PartnerLeadModel } from "../../_models/partner/PartnerLeadModel";
import { CompanyService } from "../../_services";

declare const swal: any;
declare const $: any;

@Component({
    selector: ".m-grid.m-grid--hor.m-grid--root.m-page",
    templateUrl: "./signup.component.html",
    styleUrls: ["./signup.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [PartnerService, CompanyService]
})

export class SignupComponent implements OnInit {

    partnerCreate = new PartnerLeadModel();
    kycDocTypeList = new Array<string>();
    kycDocUploadedList = new Array<string>();

    kycDocumentsModel = new Array<KYCDocumentsModel>();
    documentURL: string = 'isAgent=YES';
    selectedDoc = new Array<any>();
    currentUserRegister: any;
    showThankYou: boolean = false;
    proceedToRegisterBt = false;
    public cities: any;

    clientIP: any;
    clientLat: any;
    clientLong: any;
    clientBrowser = '';
    geolocationPosition: any;

    constructor(private _router: Router, private _PartnerService: PartnerService, private companyService: CompanyService,
        private _authService: AuthenticationService) {
    }

    ngOnInit(): void {
        this.getDocumetList();
        this.getCities();
        this.handleSignInFormSubmit();

        // this.getIPDetails();
        this.getLocation();
    }

    getIPDetails() {

        this._authService.getIpDetails().subscribe(data => {
            this.clientIP = JSON.parse(data['_body']).ip
            this.clientIP = btoa(this.clientIP);
        });
    }

    getLocation() {

        if (window.navigator && window.navigator.geolocation) {

            window.navigator.geolocation.getCurrentPosition(
                position => {
                    this.geolocationPosition = position;

                    this.clientLat = position['coords']['latitude'];
                    this.clientLong = position['coords']['longitude'];

                },
                error => {
                }
            );
            this.getIPDetails();

            this.clientBrowser = navigator.platform;
            // this.clientBrowser = navigator.userAgent;
            // this.clientBrowser = navigator.platform;
        } else {
            this.getIPDetails();

        }
    }

    getCities() {
        this._PartnerService.getCities().subscribe(res => {
            this.cities = res.json();
        }, err => {
            console.log(err);
        });
    }

    getDocumetList() {
        this.companyService.getKYCDocs(this.documentURL)
            .subscribe(result => {
                this.kycDocumentsModel = <KYCDocumentsModel[]>result.json();
                for (let kycMedium of this.kycDocumentsModel) {
                    this.kycDocTypeList.push(kycMedium.documentName);
                }
            }, error => {
                let err = error.json();
                console.log(err.message);
            });
    }

    addPartner() {
        this.proceedToRegisterBt = true;
        this._PartnerService.addPartnerLeadCreate(this.partnerCreate).subscribe(
            result => {

                this.currentUserRegister = result.json();
                this.selectedDoc.forEach(event => {
                    this.onFileUpload(event);
                });

                this._PartnerService.sentNotificationMail(this.currentUserRegister.id).subscribe(
                    result => {
                        this.showThankYou = true;
                    },
                    error => {
                        let err = error.json();
                        console.log(err.message);
                    }
                );
            },
            error => {
                let err = error.json();
                console.log(err.message);
            }
        );
    }

    addSelectedDoc(event) {
        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
            let file: File = fileList[0];
            if (file.type.indexOf('pdf') >= 0 || file.type.indexOf('image') >= 0) {
                let formData: FormData = new FormData();
                formData.append("file", file, file.name);
                formData.append("ownerType", "PARTNER");
                formData.append("type", event.target.id);
                this.selectedDoc.push(formData);
                this.kycDocUploadedList.push(event.target.id);
            }
        }
    }

    deleteDocument(index) {
        this.selectedDoc.splice(index, 1);
        this.kycDocUploadedList.splice(index, 1);
    }

    onFileUpload(formData) {
        formData.append("ownerId", this.currentUserRegister.id);
        this.companyService.uploadDocuments(formData).subscribe(
            data => {
                console.log("File Upload result: " + JSON.stringify(data));
            },
            error => {
                console.log(error)
            }
        );

    }

    private handleSignInFormSubmit() {
        setTimeout(function() {
            $("#m_partner").click(e => {
                let form = $(e.target).closest("form");
                form.validate({
                    rules: {
                        firstName: {
                            required: true
                        },
                        lastName: {
                            required: true
                        },
                        city: {
                            required: true,
                            email: true
                        },
                        mobile: {
                            required: true
                        },
                        email: {
                            required: true
                        },
                        partnerName: {
                            required: true
                        },
                        panNumber: {
                            required: true
                        },
                        gstNumber: {
                            required: true
                        }
                    }
                });
                if (!form.valid()) {
                    e.preventDefault();
                    return;
                }
            });
        }, 0);
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/signup/signup.component.ts